import { render } from "./TeamView.vue?vue&type=template&id=527e6f8f"
import script from "./TeamView.vue?vue&type=script&lang=js"
export * from "./TeamView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__